// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"767a380b","222":"dac9dd49","302":"be7b325b","304":"8c4d60c7","333":"17b09ff9","363":"613219b0","369":"ce159937","389":"c4a9f142","671":"e97d02e9","872":"cf325f31","895":"b375d32e"}[chunkId] + ".chunk.js";
};